import Joi from 'joi';

import { attachments, optionalString, requiredString } from '../../../../utils/validators';
import { MAX_NO_OF_POLL_QUESTION_OPTIONS, MIN_NO_OF_POLL_QUESTION_OPTIONS } from '../constants';
import { FormValues } from './types';

export const validationSchema = Joi.object<FormValues, true>({
  description: optionalString,
  attachments,
  options: Joi.array()
    .items(
      Joi.object({
        optionId: requiredString,
        text: optionalString,
        type: Joi.string().pattern(/text/),
      })
        .unknown(true)
        .required()
    )
    .min(MIN_NO_OF_POLL_QUESTION_OPTIONS)
    .max(MAX_NO_OF_POLL_QUESTION_OPTIONS)
    .required(),
});

export const finalValidationSchema = Joi.object<FormValues, true>({
  description: requiredString,
  attachments,
  options: Joi.array()
    .items(
      Joi.object({
        optionId: requiredString,
        text: requiredString,
        type: Joi.string().pattern(/text/),
      })
        .unknown(true)
        .required()
    )
    .min(MIN_NO_OF_POLL_QUESTION_OPTIONS)
    .max(MAX_NO_OF_POLL_QUESTION_OPTIONS)
    .required(),
});
